<template>
  <v-dialog width="500" v-model="isOpen">
    <v-card rounded="0" class="d-flex justify-center flex-column pa-6">
      <div class="d-flex justify-space-between align-center mx-6 mb-5">
        <v-icon color="error" x-large class="exit-warning-icon mr-2">mdi-alert</v-icon>
        <v-card-title class="word-break align-text-left exit-warning-text">
          <Typography variant="h-5" as="span"> Do you have a GDPR data request? </Typography>
        </v-card-title>
      </div>
      <Typography variant="body-1" as="span" class="word-break exit-warning-text">
        Please contact our GDPR data officer at
        <a :href="gdprMailto">{{ gdprEmail }}</a>
        for all requests. Please include your name and details on your request.
      </Typography>
      <v-card-actions class="mx-12">
        <Button color="brandPrimary" outlined style="width: 130px" @click="isOpen = false">
          Close
        </Button>
        <v-spacer />
        <Button color="brandPrimary" style="width: 130px" @click="openMailto(gdprMailto)">
          Email
        </Button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Button from "@/components/generic/Button.vue";
import Typography from "@/components/generic/Typography.vue";
import { GDPR_PRIVACY_EMAIL, gdprPrivacyMailto } from "@/constants/legalDocuments";

export default {
  name: "GdprRequestDialog",
  components: { Button, Typography },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isOpen: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    gdprEmail() {
      return GDPR_PRIVACY_EMAIL;
    },
    gdprMailto() {
      return gdprPrivacyMailto();
    },
  },
  methods: {
    openMailto(href) {
      window.location.href = href;
    },
  },
};
</script>
